import React from "react";
import { Editor as TinyEditor } from '@tinymce/tinymce-react';
import $ from 'jquery';

function Editor({ initialValue = '', id, name, disabled = false, classes, handleChange, ...rest }) {
    return (
        <TinyEditor
            id={id}
            value={initialValue}
            name={name}
            disabled={disabled}
            className={classes}
            placeholder={`Enter ${name.replace(/_/g, ' ').toLowerCase()}`}
            {...rest}
            init={{
                height: 500,
                menubar: "tools",
                selector: `textarea`,
                skin: 'custom',
                valid_elements: '*',
                valid_styles: '*',
                apply_source_formatting: true,
                verify_html: false,
                verify_css_classes: false,
                inline_styles: true,
                preformatted: true,
                entity_encoding: 'raw',
                content_style: "p { margin: 0; }body { line-height: 1; color: white; }",
                fullscreen_native: true,
                forced_root_block: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar:
                    "fullscreen | " +
                    "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | code ",

                toolbar_mode: 'sliding',

                setup: function (editor) {
                    editor.on('FullscreenStateChanged', function (e) {
                        if (e.state) {
                            $('.modal-dialog').attr('style', 'transform: none !important');
                        } else {
                            $('.modal-dialog').attr('style', 'transform: translate(0,0)');
                        }
                    });
                }
            }}
            onEditorChange={(content, editor) => {
                let e = {};
                e.target = {};
                e.target["name"] = name;
                e.target["value"] = content;
                handleChange(e);
            }}
        />
    )

}

export default Editor;